module.exports = __webpack_public_path__ + "img/DrawKit Vector Illustration Landscape & Scenery (1).e67cd476.svg";